import { useDateFnsFormattersWithLocale } from "@tellescope/ui";

export interface MaskedDateHelperTextProps {
  value: Date | null;
  includeTime?: boolean;
}

export const MaskedDateHelperText = ({ value, includeTime }: MaskedDateHelperTextProps) => {
  const { format } = useDateFnsFormattersWithLocale();

  if (!value) return null;

  return (
    <p className="text-sm text-muted-foreground">
      {format(value, includeTime ? "MMMM d, yyyy 'at' h:mm a" : "MMMM d, yyyy")}
    </p>
  );
};
